import { DEFAULT_MENU_THEME } from "../../../config/menuThemes";
import ClassicFoodDetailTheme from "./ClassicFoodDetailTheme";
import GardenFreshFoodDetailTheme from "./GardenFreshFoodDetailTheme";
import JapaneseMinimalFoodDetailTheme from "./JapaneseMinimalFoodDetailTheme";
import BrewBitesFoodDetailTheme from "./BrewBitesFoodDetailTheme";
import NovaFoodDetailTheme from "./NovaFoodDetailTheme";
import MizbanSignatureFoodDetailTheme from "./MizbanSignatureFoodDetailTheme";
import LuxuryWhiteFoodDetailTheme from "./LuxuryWhiteFoodDetailTheme";
import StreetFoodFoodDetailTheme from "./StreetFoodFoodDetailTheme";
import RoyalGoldFoodDetailTheme from "./RoyalGoldFoodDetailTheme";
import PersianHeritageFoodDetailTheme from "./PersianHeritageFoodDetailTheme";

const foodDetailThemeRegistry = {
  classic: ClassicFoodDetailTheme,
  gardenFresh: GardenFreshFoodDetailTheme,
  japaneseMinimal: JapaneseMinimalFoodDetailTheme,
  brewBites: BrewBitesFoodDetailTheme,
  nova: NovaFoodDetailTheme,
  mizbanSignature: MizbanSignatureFoodDetailTheme,
  luxuryWhite: LuxuryWhiteFoodDetailTheme,
  streetFood: StreetFoodFoodDetailTheme,
  royalGold: RoyalGoldFoodDetailTheme,
  persianHeritage: PersianHeritageFoodDetailTheme,
};

export const getFoodDetailThemeComponent = (theme) => (
  foodDetailThemeRegistry[theme] || foodDetailThemeRegistry[DEFAULT_MENU_THEME]
);

export default foodDetailThemeRegistry;
